export const SFWTranslations = {
  de: {
    shopFloorWalk: "Shop Floor Walk",
    sfwAssets: "Montageboxen",
    walkThrough: "Rundgang",
    createOrder: "Auftrag starten",
    noWorkOrderStarted: "Kein gestarteter Auftrag",
    mechanik: "Mechanik",
    elektrik: "Elektrik",
    general: "Allgemein",
    editTicketData: "Daten bearbeiten",
    finishWorkOrder: "Auftrag Abschließen",
    workOrderStarted: "Auftrag gestartet",
    createOrderDialogTitle: "Auftrag starten",

    finishWorkOrderConfirmTitle: "Auftrag abschließen",
    finishWorkOrderConfirmMessage:
      "Möchten Sie den Auftrag wirklich abschließen?",
    workOrderFinished: "Auftrag abgeschlossen",
    walkThroughView: "Rundgang",
    more: "Mehr",
    noAssets: "Keine Anlagen gefunden",
    sfwOrderHistory: "Aufträge",
    sfwWalkthroughStatus: "Rundgangsstatus",
    sfwWalkthroughStatusDescription: "Status des Rundgangs",
    templateNotFound: "Schablone nicht gefunden",
    transferToNextStation: "Transferieren",
    transferDialogTitle: "Auftrag transferieren",
    targetStation: "Zielstation",
    transferNote: "Notiz (optional)",
    transfer: "Transferieren",
    transferSuccess: "Auftrag transferiert an {name}",
    sfwTicketHistory: "Ticket-Historie",
    assignedAt: "Zugewiesen am",
    unassignedAt: "Abgewiesen am",
    sfwCurrentlyActive: "Aktuell aktiv",
    processingHistory: "Verarbeitungshistorie",
    reopenWorkOrder: "Auftrag wiedereröffnen",
    reopenWorkOrderConfirmTitle: "Auftrag wiedereröffnen",
    reopenComment: "Kommentar (optional)",
    workOrderReopened: "Auftrag wiedereröffnet",
    history: "Historie",
  },
  en: {
    shopFloorWalk: "Shop Floor Walk",
    sfwAssets: "Assembly Boxes",
    walkThrough: "Walk-through",
    createOrder: "Start work order",
    noWorkOrderStarted: "No work order started",
    mechanik: "Mechanics",
    elektrik: "Electrics",
    general: "General",
    editTicketData: "Edit data",
    workOrderStarted: "Work order started",
    createOrderDialogTitle: "Start Work Order",
    finishWorkOrder: "Finish Work Order",
    finishWorkOrderConfirmTitle: "Finish work order",
    finishWorkOrderConfirmMessage:
      "Are you sure you want to finish this work order?",
    workOrderFinished: "Work order finished",
    walkThroughView: "Walk-through",
    more: "More",
    noAssets: "No assets found",
    sfwWalkthroughStatus: "Walk-through Status",
    sfwWalkthroughStatusDescription: "Walk-through status",
    sfwOrderHistory: "Orders",
    templateNotFound: "Template not found",
    transferToNextStation: "Transfer",
    transferDialogTitle: "Transfer work order",
    targetStation: "Target station",
    transferNote: "Note (optional)",
    transfer: "Transfer",
    transferSuccess: "Work order transferred to {name}",
    sfwTicketHistory: "Ticket History",
    assignedAt: "Assigned",
    unassignedAt: "Unassigned",
    sfwCurrentlyActive: "Currently active",
    processingHistory: "Processing History",
    reopenWorkOrder: "Reopen Work Order",
    reopenWorkOrderConfirmTitle: "Reopen work order",
    reopenComment: "Comment (optional)",
    workOrderReopened: "Work order reopened",
    history: "History",
  },
};
